<template>
  <div class="task-section">
    <div class="task-header">
      <h3 class="task-title">{{ title }}</h3>
    </div>

    <!-- Scrollable parent of TaskItem -->
    <div class="task-scroll">
      <TaskGroup
        v-for="(group, gi) in groups"
        :key="gi"
        :title="group.title"
        :items="group.items"
        :steps-time="stepsTime"
        :substep-metrics="substepMetrics"
        :optional-steps="optionalSteps"
        :negative-steps="negativeSteps"
      />
    </div>
  </div>
</template>

<script>
import TaskGroup from './TaskGroup.vue';

export default {
  name: 'TaskSection',
  components: { TaskGroup },
  props: {
    title: { type: String, default: 'Task Definition' },
    stepsList: { type: Array, default: () => [] },
    stepsTime: { type: Object, default: () => ({}) },
    substepMetrics: { type: Object, default: () => ({}) },
    optionalSteps: { type: Array, default: () => [] },
    negativeSteps: { type: Array, default: () => [] },
  },
  computed: {
    groups() {
      let currentStepIndex = -1;
      let stepsGroups = [];
      this.stepsList.forEach((step) => {
        if (step.type === 'step') {
          stepsGroups.push({ title: step.name, items: [] });
          currentStepIndex++;
          return;
        }
        stepsGroups[currentStepIndex].items.push({
          title: step.name,
          substepIndex: step.substepIndex,
        });
      });
      return stepsGroups;
    },
  },
};
</script>

<style scoped>
.task-section {
  background: #ffffff;
  border-radius: var(--radius);
  border: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  min-height: 0;
  width: 100%;
}

.task-header {
  padding: var(--card-pad);
  border-bottom: 1px solid #eef0f3;
}

.task-title {
  font-size: var(--fs-h);
  font-weight: 800;
  color: #0f172a;
  margin: 0;
}

/* This is the auto-scrolling parent for TaskItem */
.task-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: var(--card-pad);
}

/* Visually nice, thin scrollbars */
.task-scroll::-webkit-scrollbar {
  width: 8px;
}
.task-scroll::-webkit-scrollbar-track {
  background: #f3f4f6;
  border-radius: 6px;
}
.task-scroll::-webkit-scrollbar-thumb {
  background: #c7cbd1;
  border-radius: 6px;
}
.task-scroll {
  scrollbar-width: thin;
  scrollbar-color: #c7cbd1 #f3f4f6;
}
</style>
